import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  getCurrentLanguage,
  normalizeLanguage,
  type AppLanguage
} from './languages';

const HTML_LANG: Record<AppLanguage, string> = {
  zh: 'zh-CN',
  en: 'en',
  vi: 'vi'
};

function syncDocument(lang: AppLanguage) {
  const html = document.documentElement;
  html.lang = HTML_LANG[lang];
  html.setAttribute('data-lang', lang);
  html.classList.toggle('lang-vn', lang === 'vi');
}

i18n.use(initReactI18next).init({
  resources,
  lng: getCurrentLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnNull: false
});

syncDocument(getCurrentLanguage());

i18n.on('languageChanged', (lng) => {
  const lang = normalizeLanguage(lng);
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // ignore storage errors (private mode etc.)
  }
  syncDocument(lang);
});

export function changeLanguage(lang: AppLanguage) {
  return i18n.changeLanguage(lang);
}

export { useTranslation } from 'react-i18next';
export { getCurrentLanguage, LANGUAGE_OPTIONS } from './languages';
export type { AppLanguage } from './languages';

export default i18n;
